<script>
    import PlannerMap from '@js/components/maps/PlannerMap.svelte';

    const {
        // rideType,
        mapId
    } = $props();
</script>

<PlannerMap mapId={mapId}
            reusePreviousTracks={false}/>
